// 视频控制功能 - 切换静音
function toggleMute(videoId) {
  const video = document.getElementById(videoId);
  if (!video) return;
  
  const btn = event.currentTarget;
  const muteIcon = btn.querySelector('.mute-icon');
  const unmuteIcon = btn.querySelector('.unmute-icon');
  
  if (video.muted) {
    video.muted = false;
    muteIcon.classList.add('hidden-important');
    unmuteIcon.classList.remove('hidden-important');
  } else {
    video.muted = true;
    muteIcon.classList.remove('hidden-important');
    unmuteIcon.classList.add('hidden-important');
  }
}

// 视频控制功能 - 切换播放/暂停
function togglePlay(videoId) {
  const video = document.getElementById(videoId);
  if (!video) return;
  
  const btn = event.currentTarget;
  const playIcon = btn.querySelector('.play-icon');
  const pauseIcon = btn.querySelector('.pause-icon');
  
  // 获取同级的声音控制按钮
  const muteBtn = btn.parentElement?.querySelector('.mute-toggle') || 
                  btn.parentElement?.parentElement?.querySelector('.mute-toggle');
  
  if (video.paused) {
    // 播放视频时，如果是非自动播放视频，确保有声音
    if (!video.hasAttribute('autoplay')) {
      video.muted = false;
      
      // 同步更新声音按钮状态
      if (muteBtn) {
        const muteIcon = muteBtn.querySelector('.mute-icon');
        const unmuteIcon = muteBtn.querySelector('.unmute-icon');
        if (muteIcon && unmuteIcon) {
          muteIcon.classList.add('hidden-important');
          unmuteIcon.classList.remove('hidden-important');
        }
      }
    }
    
    video.play().catch(e => {
      console.log('视频播放失败:', e);
      // 如果播放失败，可能是因为浏览器策略，尝试静音播放
      video.muted = true;
      video.play().catch(err => console.log('静音播放也失败:', err));
      
      // 更新声音按钮状态为静音
      if (muteBtn) {
        const muteIcon = muteBtn.querySelector('.mute-icon');
        const unmuteIcon = muteBtn.querySelector('.unmute-icon');
        if (muteIcon && unmuteIcon) {
          muteIcon.classList.remove('hidden-important');
          unmuteIcon.classList.add('hidden-important');
        }
      }
    });
    
    // 更新播放按钮状态
    if (playIcon && pauseIcon) {
      playIcon.classList.add('hidden-important');
      pauseIcon.classList.remove('hidden-important');
    }
  } else {
    video.pause();
    
    // 更新播放按钮状态
    if (playIcon && pauseIcon) {
      playIcon.classList.remove('hidden-important');
      pauseIcon.classList.add('hidden-important');
    }
  }
}

// 初始化延迟加载视频
function initLazyVideos() {
  const lazyVideos = document.querySelectorAll('.lazy-video');
  lazyVideos.forEach(video => {
    // 预加载视频元数据，确保尺寸计算正确
    if (video.getAttribute('data-src')) {
      // 创建一个临时视频元素来获取尺寸，但不加载完整视频
      let tempVideo = new Audio();
      tempVideo.preload = 'metadata';
      tempVideo.onloadedmetadata = function() {
        // 元数据加载完成，现在我们知道视频的尺寸了
        tempVideo = null; // 释放资源
      };
      tempVideo.src = video.getAttribute('data-src');
    }
    
    const playBtn = video.parentElement.parentElement.querySelector('.play-toggle');
    if (playBtn) {
      playBtn.addEventListener('click', function() {
        if (video.getAttribute('data-src') && !video.getAttribute('src')) {
          video.setAttribute('src', video.getAttribute('data-src'));
          video.removeAttribute('data-src');
        }
      });
    }
  });

  // 如果视频在视口中，加载视频
  document.querySelectorAll('video.lazy-video').forEach((el) => {
    if (el.getBoundingClientRect().top < 150) {
      const poster = el.dataset.poster;
      const src = el.dataset.src;
      if (poster) {
        el.setAttribute('poster', poster);
        el.removeAttribute('data-poster');
      }
      if (src) {
        el.setAttribute('src', src);
        el.removeAttribute('data-src');
      }
    }
  });
}

// 初始化视频可见性监听，进入视图自动播放，离开视图自动暂停
function initVideoVisibilityObserver() {
  const videos = document.querySelectorAll('video');
  if (!videos.length) return;
  
  // 创建视图监听器
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      
      // 视频进入视图
      if (entry.isIntersecting) {
        // 判断是否是延迟加载视频，并加载源
        if (video.hasAttribute('data-src') && !video.getAttribute('src')) {
          video.setAttribute('src', video.getAttribute('data-src'));
          video.removeAttribute('data-src');
        }
        
        // 只有自动播放视频才会在进入视图时自动播放
        if (video.hasAttribute('autoplay')) {
          video.play().catch(e => {
            // 自动播放可能失败（浏览器策略），静音后尝试播放
            video.muted = true;
            video.play().catch(err => console.log('无法自动播放视频:', err));
          });
          
          // 更新播放/暂停按钮状态（如果存在）
          const playBtn = video.parentElement?.parentElement?.querySelector('.play-toggle');
          if (playBtn) {
            const playIcon = playBtn.querySelector('.play-icon');
            const pauseIcon = playBtn.querySelector('.pause-icon');
            if (playIcon && pauseIcon) {
              playIcon.classList.add('hidden-important');
              pauseIcon.classList.remove('hidden-important');
            }
          }
        }
      } 
      // 视频离开视图
      else {
        // 如果视频正在播放则暂停（对所有播放中的视频生效）
        if (!video.paused) {
          video.pause();
          
          // 更新播放/暂停按钮状态（如果存在）
          const playBtn = video.parentElement?.parentElement?.querySelector('.play-toggle');
          if (playBtn) {
            const playIcon = playBtn.querySelector('.play-icon');
            const pauseIcon = playBtn.querySelector('.pause-icon');
            if (playIcon && pauseIcon) {
              playIcon.classList.remove('hidden-important');
              pauseIcon.classList.add('hidden-important');
            }
          }
        }
      }
    });
  }, {
    threshold: 0.2 // 当视频有20%在视图内时触发
  });
  
  // 为所有视频添加观察者
  videos.forEach(video => {
    observer.observe(video);
  });
}

/**
 * Content Tab Section JavaScript Functions
 * 提供content-tab section的交互功能
 */

// 初始化内容标签页
function initContentTabs() {
  const tabItems = document.querySelectorAll('tab-items');
  
  // 添加防呆设置函数
  function ensureStackLayout(tabItem) {
    const tabPosition = tabItem.getAttribute('data-tab-position');
    if (tabPosition === 'middle') {
      const contentWrappers = tabItem.querySelectorAll('.content-tab__content-wrapper');
      contentWrappers.forEach(wrapper => {
        wrapper.classList.remove('stack-layout');
      });
    }
  }
  
  tabItems.forEach(tabItem => {
    // 初始化时执行防呆设置
    ensureStackLayout(tabItem);
    
    // 初始化激活状态
    const middleTabContainer = tabItem.querySelector('[data-tab-position="middle"]');
    if (middleTabContainer) {
      const firstTabItem = middleTabContainer.querySelector('.collection-tab__tab-item');
      if (firstTabItem) {
        firstTabItem.classList.add('active');
      }
    }
    
    // 为中间位置的标签添加点击处理
    const middleTabs = tabItem.querySelectorAll('[data-tab-position="middle"] .collection-tab__tab-item');
    middleTabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const blockId = this.getAttribute('data-block-id');
        const allTabs = tabItem.querySelectorAll('.collection-tab__tab-item');
        const allTabContents = tabItem.querySelectorAll('.collection-tab__tab-content');
        
        // 移除所有标签的激活状态
        allTabs.forEach(t => t.classList.remove('active'));
        
        // 添加当前标签的激活状态
        this.classList.add('active');
        
        // 同步激活顶部相同的标签
        const topTabs = tabItem.querySelectorAll(':not([data-tab-position="middle"]) .collection-tab__tab-item');
        topTabs.forEach(topTab => {
          if (topTab.getAttribute('data-block-id') === blockId) {
            topTab.classList.add('active');
          } else {
            topTab.classList.remove('active');
          }
        });
        
        // 激活对应的内容
        allTabContents.forEach(content => {
          if (content.getAttribute('data-block-id') === blockId) {
            content.classList.add('active');
            content.classList.remove('invisible', 'pointer-none');
          } else {
            content.classList.remove('active');
            content.classList.add('invisible', 'pointer-none');
          }
        });
        
        // 每次切换标签后执行防呆设置
        ensureStackLayout(tabItem);
      });
    });
    
    // 同步顶部标签和中间标签的状态
    const topTabs = tabItem.querySelectorAll(':not([data-tab-position="middle"]) .collection-tab__tab-item');
    topTabs.forEach(tab => {
      const originalClickHandler = tab.onclick;
      tab.onclick = function(e) {
        if (originalClickHandler) {
          originalClickHandler.call(this, e);
        }
        
        const blockId = this.getAttribute('data-block-id');
        const middleTabs = tabItem.querySelectorAll('[data-tab-position="middle"] .collection-tab__tab-item');
        
        middleTabs.forEach(middleTab => {
          if (middleTab.getAttribute('data-block-id') === blockId) {
            middleTab.classList.add('active');
          } else {
            middleTab.classList.remove('active');
          }
        });
        
        // 每次切换标签后执行防呆设置
        ensureStackLayout(tabItem);
      };
    });
  });
}

// 初始化编辑器中的防呆功能
function initTabEditorFunctions() {
  // 监听 tab_position 变化
  const tabPositionSelect = document.querySelector('[name="section[settings][tab_position]"]');
  if (tabPositionSelect) {
    tabPositionSelect.addEventListener('change', function() {
      const stackLayoutCheckbox = document.querySelector('[name="section[settings][stack_layout]"]');
      if (stackLayoutCheckbox) {
        if (this.value === 'middle') {
          stackLayoutCheckbox.checked = false;
          stackLayoutCheckbox.disabled = true;
        } else {
          stackLayoutCheckbox.disabled = false;
        }
      }
    });
    
    // 初始化时检查
    if (tabPositionSelect.value === 'middle') {
      const stackLayoutCheckbox = document.querySelector('[name="section[settings][stack_layout]"]');
      if (stackLayoutCheckbox) {
        stackLayoutCheckbox.checked = false;
        stackLayoutCheckbox.disabled = true;
      }
    }
  }
}

// 在DOM加载完成后初始化所有功能
document.addEventListener('DOMContentLoaded', function() {
  initLazyVideos();
  initContentTabs();
  initTabEditorFunctions();
  initVideoVisibilityObserver();
  
  // 为全局对象提供方法，以便在liquid模板中调用
  window.richTextFunctions = {
    toggleMute: toggleMute,
    togglePlay: togglePlay
  };
}); 